var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
import React, { PureComponent } from 'react';
import { defaultProps } from './defaults';
import { DivTag } from '../../Utils/AtomicTag';
import { Arrows } from './Arrows';
import { Dots } from './Dots';
import { addEventListenerWrap } from '../../Utils/react';
var Carousel = /** @class */ (function (_super) {
    __extends(Carousel, _super);
    function Carousel(props) {
        var _this = _super.call(this, props) || this;
        _this.transitionEvent = null;
        _this.autoPlayTimer = 0;
        _this.wrapRef = React.createRef();
        _this.componentDidMount = function () {
            _this.getWrapWidth();
            _this.initWrapPosition();
            _this.setArrowsState();
            _this.props.autoPlay && _this.goPlay();
            _this.transitionEvent = addEventListenerWrap(_this.wrapRef.current, 'transitionend', _this.onTransitionEnd);
        };
        _this.getWrapWidth = function () {
            var iWidth = _this.props.iWidth;
            var wrap = _this.wrapRef.current;
            if (wrap) {
                var itemNodes = wrap.querySelectorAll('.carousel-item');
                var wrapWidth = 0;
                for (var i = 0; i < itemNodes.length; i++) {
                    var itemWidth = itemNodes[i].getBoundingClientRect().width;
                    wrapWidth += iWidth || itemWidth;
                }
                _this.setState({
                    wrapWidth: wrapWidth,
                });
            }
        };
        _this.initWrapPosition = function () {
            var childrenLength = _this.state.childrenLength;
            var _a = _this.props, iWidth = _a.iWidth, loop = _a.loop, defaultIndex = _a.defaultIndex;
            var initIndex = 0;
            if (defaultIndex > childrenLength - 1 || defaultIndex < 0) {
                initIndex = 0;
            }
            else {
                initIndex = defaultIndex;
            }
            _this.setState({
                currIndex: initIndex,
            });
            var left = loop ? iWidth * (childrenLength + initIndex) : iWidth * initIndex;
            _this.setTransform(left, false);
        };
        _this.onTransitionEnd = function () {
            _this.setState({
                running: false,
            });
            if (_this.props.loop) {
                _this.resetWrapPosition();
            }
            else {
                _this.setArrowsState();
            }
        };
        _this.resetWrapPosition = function () {
            var _a = _this.state, childrenLength = _a.childrenLength, wrapLeft = _a.wrapLeft;
            var _b = _this.props, iWidth = _b.iWidth, loop = _b.loop, widthUnit = _b.widthUnit;
            var maxLeft = iWidth * (childrenLength * 2), minLeft = iWidth * childrenLength;
            if (loop) {
                var left = 0;
                if (wrapLeft >= maxLeft) {
                    left = wrapLeft - iWidth * childrenLength;
                    _this.setTransform(left, false);
                }
                else if (wrapLeft < minLeft) {
                    left = wrapLeft + iWidth * childrenLength;
                    _this.setTransform(left, false);
                }
            }
        };
        _this.setTransform = function (wrapLeft, duration) {
            var wrap = _this.wrapRef.current;
            var _a = _this.props, loop = _a.loop, widthUnit = _a.widthUnit, step = _a.step, visibleNum = _a.visibleNum;
            var childrenLength = _this.state.childrenLength;
            if (widthUnit == '%') {
                wrapLeft = wrapLeft / (loop ? (childrenLength * 3) / visibleNum : childrenLength);
            }
            if (wrap) {
                wrap.style.transform = "translate( -" + wrapLeft + widthUnit + ", 0)";
                if (duration) {
                    wrap.style.transition = "transform " + _this.props.speed + "s ease-in-out";
                }
                else {
                    wrap.style.transitionProperty = 'none';
                }
                _this.setState({
                    wrapLeft: wrapLeft,
                });
            }
        };
        _this.setArrowsState = function () {
            var _a = _this.props, loop = _a.loop, autoPlay = _a.autoPlay;
            if (loop) {
                return;
            }
            var canNext = true, canPrev = true;
            if (_this.isLast()) {
                canNext = false;
                autoPlay && _this.pausePlay();
            }
            else if (_this.isFirst()) {
                canPrev = false;
                autoPlay && _this.pausePlay();
            }
            _this.setState({
                canNext: canNext,
                canPrev: canPrev,
            });
        };
        _this.isFirst = function () {
            return _this.state.currIndex - _this.props.step < 0;
        };
        _this.isLast = function () {
            return _this.state.currIndex + _this.props.step > _this.state.childrenLength - 1;
        };
        /**
         * 左右切换
         * @param nextIndex 下一帧
         */
        _this.goTo = function (nextIndex) {
            var _a = _this.state, canNext = _a.canNext, canPrev = _a.canPrev, childrenLength = _a.childrenLength, running = _a.running;
            var _b = _this.props, iWidth = _b.iWidth, loop = _b.loop, onChange = _b.onChange;
            if (running) {
                return;
            }
            var left = 0;
            if (!loop) {
                left = nextIndex * iWidth;
            }
            else {
                left = (nextIndex + childrenLength) * iWidth;
                if (nextIndex > childrenLength - 1) {
                    nextIndex = nextIndex - childrenLength; // 已考虑step溢出
                }
                else if (nextIndex < 0) {
                    nextIndex = nextIndex + childrenLength; // 已考虑step溢出
                }
            }
            _this.setTransform(left, true);
            _this.setState({
                running: true,
                currIndex: nextIndex,
                wrapLeft: left,
                canNext: canNext,
                canPrev: canPrev,
            }, function () {
                onChange(nextIndex, _this);
            });
        };
        _this.goPrev = function () {
            _this.goTo(_this.state.currIndex - _this.props.step);
        };
        _this.goNext = function () {
            _this.goTo(_this.state.currIndex + _this.props.step);
        };
        _this.goPlay = function () {
            var _a = _this.props, step = _a.step, interval = _a.interval, children = _a.children, autoPlay = _a.autoPlay;
            var _b = _this.state, childrenLength = _b.childrenLength, canNext = _b.canNext;
            if (!autoPlay || !canNext) {
                return;
            }
            if (children && childrenLength > 1) {
                _this.autoPlayTimer = window.setInterval(function () {
                    _this.goTo(_this.state.currIndex + step);
                }, interval * 1000);
            }
        };
        _this.pausePlay = function () {
            if (!_this.props.autoPlay) {
                return;
            }
            clearInterval(_this.autoPlayTimer);
        };
        _this.handleMouseOver = function () {
            _this.pausePlay();
        };
        _this.handleMouseOut = function () {
            _this.goPlay();
        };
        _this.componentWillUnmount = function () {
            clearInterval(_this.autoPlayTimer);
            _this.transitionEvent && _this.transitionEvent.remove();
        };
        _this.renderChildren = function () {
            var wraperAtomics = ['flex', 'box-border'];
            var _a = _this.props, children = _a.children, loop = _a.loop, iWidth = _a.iWidth, widthUnit = _a.widthUnit;
            var wrapWidth = _this.state.wrapWidth;
            if (!children) {
                return null;
            }
            var loopChild;
            var childrenArr = React.Children.toArray(children);
            if (children && loop) {
                loopChild = __spread(childrenArr, childrenArr, childrenArr);
            }
            else {
                loopChild = __spread(childrenArr);
            }
            return (React.createElement(DivTag, { className: "carousel-wrap", atomics: wraperAtomics, ref: _this.wrapRef, style: { width: "" + wrapWidth + widthUnit } }, React.Children.map(loopChild, function (child, index) {
                return React.cloneElement(child, __assign(__assign({}, child.props), { key: "" + index, id: "" + index, className: "carousel-item", style: { width: "" + iWidth + widthUnit } }));
            })));
        };
        _this.state = {
            currIndex: 0,
            wrapWidth: 0,
            wrapLeft: 0,
            canNext: true,
            canPrev: true,
            running: false,
            childrenLength: React.Children.count(_this.props.children),
        };
        return _this;
    }
    Carousel.prototype.render = function () {
        var _this = this;
        var _a = this.props, visibleNum = _a.visibleNum, iWidth = _a.iWidth, hasArrows = _a.hasArrows, hasDots = _a.hasDots, children = _a.children, leftIcon = _a.leftIcon, rightIcon = _a.rightIcon, widthUnit = _a.widthUnit, defaultIndex = _a.defaultIndex, className = _a.className, style = _a.style, onChange = _a.onChange, rest = __rest(_a, ["visibleNum", "iWidth", "hasArrows", "hasDots", "children", "leftIcon", "rightIcon", "widthUnit", "defaultIndex", "className", "style", "onChange"]);
        var _b = this.state, canPrev = _b.canPrev, canNext = _b.canNext, currIndex = _b.currIndex, childrenLength = _b.childrenLength;
        var carouselAtomics = ['relative', 'overflow-hidden'];
        return (React.createElement(DivTag, __assign({ name: Carousel.NAME, atomics: carouselAtomics, className: className + " carousel", style: __assign({ width: iWidth * visibleNum + widthUnit }, style), onMouseOver: this.handleMouseOver, onMouseOut: this.handleMouseOut }, rest),
            this.renderChildren(),
            hasArrows && childrenLength > 1 && (React.createElement(Arrows, { canPrev: canPrev, canNext: canNext, leftIcon: leftIcon, rightIcon: rightIcon, goPrev: function () { return _this.goPrev(); }, goNext: function () { return _this.goNext(); } })),
            hasDots && childrenLength > 1 && (React.createElement(Dots, { currIndex: currIndex, goTo: function (index) { return _this.goTo(index); } }, children))));
    };
    Carousel.defaultProps = defaultProps;
    Carousel.NAME = 'carousel';
    Carousel.displayName = 'Carousel';
    return Carousel;
}(PureComponent));
export { Carousel };
